import { FunctionComponent, memo } from "react";
import { IProps } from "./select-search-type.types";
import { SearchType } from "@edgetier/watchtower-types";
import { SelectEnum } from "@edgetier/select";
import "./select-search-type.scss";

/**
 * A select field for choose a phrase trigger search type.
 * @param props.name       The name for the select field.
 * @param props.otherProps Props to be applied to the select field.
 * @returns
 */
const SelectSearchType: FunctionComponent<IProps> = ({ name = "searchTypeId", ...otherProps }) => (
    <SelectEnum
        {...otherProps}
        description="search type"
        name={name}
        items={SearchType}
        isSearchable={false}
        excludeItems={[SearchType.Regex]}
        isSingleSelect
    />
);
export default memo(SelectSearchType);
